import MomentAssetPicker from '../MomentAssetPicker'
import ConfirmationModal from './ActiveModal/ConfirmationModal'

const modals = ({ deleteEntity, onSaveAsset, uploadAsset }) => ({
  asset: ({ entity, deactivateModalState }) => (
    <MomentAssetPicker
      moment={entity}
      onClose={deactivateModalState}
      onSaveAsset={onSaveAsset}
      uploadAsset={uploadAsset}
    />
  ),
  delete: ({ entity, deactivateModalState }) => (
    <ConfirmationModal
      entity={entity}
      onClose={deactivateModalState}
      onConfirm={() => deleteEntity(entity)}
      title={getTitle(entity)}
      message={getMessage(entity)}
      type="delete"
    />
  ),
})

function getTitle(entity) {
  let title = `Are you sure you want to delete this ${entity.type}?`

  switch (entity.type) {
    case 'content':
    case 'moment':
      title = 'Are you sure you want to delete this?'
      break
    default:
      break
  }

  return title
}

function getMessage(entity) {
  let message = 'You cannot undo this action.'

  switch (entity.type) {
    case 'content':
      message =
        'Deleting this content will remove it everywhere in Opal. ' + message
      break
    case 'moment':
      message =
        'Deleting this moment will also delete any content within it. ' +
        message
      break
    default:
      break
  }

  return message
}

export default modals
